import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=2e1bab84&"
import script from "./RoleEdit.vue?vue&type=script&lang=js&"
export * from "./RoleEdit.vue?vue&type=script&lang=js&"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports